import axiosInstance from '../api/axios';
import qs from "qs";

export const getAllFeedbackStudents = async (
    mailType,
    feedbackStatus,
    batch,
    reportType,
    programId
    ) => {
    try {
        const response = await axiosInstance.get("/feedback-recipients", {
        params: {
            mailType,
            feedbackStatus,
            batch,
            reportType,
            programId,
        },
        paramsSerializer: params =>
            qs.stringify(params, { arrayFormat: "repeat" }),
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching feedback students:", error);
        throw error;
    }
};

export const getAllVivaStatusStudents = async (
    mailType,
    vivaIndiStatus,
    batch,
    reportType,
    programId
    ) => {
    try {
        const response = await axiosInstance.get("/vivaStatus-recipients", {
        params: {
            mailType,
            vivaIndiStatus,
            batch,
            reportType,
            programId,
        },
        paramsSerializer: params =>
            qs.stringify(params, { arrayFormat: "repeat" }),
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching Viva Schedule students:", error);
        throw error;
    }
};

export const getAllAnnouncementStudents = async (
    mailType,
    batch,
    reportType,
    programId
    ) => {
    try {
        const response = await axiosInstance.get("/announcement-recipients", {
        params: {
            mailType,
            batch,
            reportType,
            programId,
        },
        paramsSerializer: params =>
            qs.stringify(params, { arrayFormat: "repeat" }),
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching announcement students:", error);
        throw error;
    }
};

export const getAllVivaScheduleStudents = async (
    mailType,
    batch,
    reportType,
    programId
    ) => {
    try {
        const response = await axiosInstance.get("/vivaSchedule-recipients", {
        params: {
            mailType,
            batch,
            reportType,
            programId,
        },
        paramsSerializer: params =>
            qs.stringify(params, { arrayFormat: "repeat" }),
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching viva schedule students:", error);
        throw error;
    }
};

export const getAllSessionStudents = async (
    mailType,
    batch,
    programId
    ) => {
    try {
        const response = await axiosInstance.get("/session-recipients", {
        params: {
            mailType,
            batch,
            programId,
        },
        paramsSerializer: params =>
            qs.stringify(params, { arrayFormat: "repeat" }),
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching session students:", error);
        throw error;
    }
};